import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent } from '../layout/main-layout/main-layout.component';
import { SuppliersComponent } from './suppliers.component';
import { Layouts } from '../app.component'
import { MaintainSupplierComponent } from './maintain-supplier/maintain-supplier.component';
import { ListSupplierComponent } from './list-supplier/list-supplier.component';

const routes: Routes = [
  {
    path: 'suppliers',
    component: SuppliersComponent,
    data: { layout: Layouts.Main }
  },
  {
    path: 'supplier/create',
    component: MaintainSupplierComponent,
    data: { layout: Layouts.Main 
    },
  },
  {
    path: 'supplier/list',
    component: ListSupplierComponent,
    data: { layout: Layouts.Main 
    },
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SuppliersRoutingModule { }
